// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aboutPage_wrapper__3vSsl","subSubWrapper":"aboutPage_subSubWrapper__3Pc4A","subWrapper":"aboutPage_subWrapper__1dX-q"};